/**
 * Menghitung usia dalam format string (tahun, bulan, hari).
 * @param birthDate - Tanggal lahir anak (bisa berupa Date, string, atau number).
 * @returns Usia dalam format string atau 'N/A' jika tanggal lahir tidak valid.
 */
export const calculateAge = (birthDate: Date | string | number | null): string => {
    if (!birthDate) return 'N/A';
    const birth = new Date(birthDate);
    const now = new Date();

    let years = now.getFullYear() - birth.getFullYear();
    let months = now.getMonth() - birth.getMonth();
    let days = now.getDate() - birth.getDate();

    if (days < 0) {
        months--;
        days += new Date(now.getFullYear(), now.getMonth(), 0).getDate();
    }

    if (months < 0) {
        years--;
        months += 12;
    }

    if (years > 0) {
        return `${years} tahun, ${months} bulan`;
    }
    if (months > 0) {
        return `${months} bulan, ${days} hari`;
    }
    return `${days} hari`;
};

/**
 * Menghitung usia dalam total bulan.
 * @param birthDate - Tanggal lahir anak (bisa berupa Date, string, atau number).
 * @returns Total usia dalam bulan, atau 0 jika tidak valid.
 */
export const calculateAgeMonths = (birthDate: Date | string | number | null): number => {
    if (!birthDate) return 0;
    const birth = new Date(birthDate);
    const now = new Date();

    let months = (now.getFullYear() - birth.getFullYear()) * 12;
    months -= birth.getMonth();
    months += now.getMonth();

    // Jika tanggal saat ini lebih kecil dari tanggal lahir di bulan yang sama, kurangi satu bulan
    if (now.getDate() < birth.getDate()) {
        months--;
    }

    return months <= 0 ? 0 : months;
};
